import { RequestHeaderConfiguration } from '../../../types/ApiClientConfig';
import { SharedRequestConfiguration, SharedRequestOneSearchParameter } from '../../../types/GeneralParameter';
import {
  OneSearchSearchResponse,
  OptionalOneSearchSearchResponseWithId,
} from '../../../types/one-search/onesearch-response/SearchResponseDto';
import { convertFieldsToStrings } from '../../../util/ConvertPropertiesToString';
import { createMandatoryParameter, getRequestConfiguration } from '../../../util/one-search/RequestConfiguration';
import { removeClassSuffixForOneSearch } from '../../../util/SplitData';
import { isCommercialVanByModelId } from '../../../util/VansConfiguration';
import { GenericFetchClient, ModeSpecificFetchClient } from '../../GenericFetchClient';

export type OneSearchSearch = SharedRequestOneSearchParameter & {
  modelIdentifier?: string;
  brand?: string;
  bodyType?: string;
};

export class OneSearchSearchClient extends GenericFetchClient implements ModeSpecificFetchClient {
  constructor(config: RequestHeaderConfiguration) {
    super(config);
    this.setPathSegment('/search');
  }

  getInflateIdLength(): number {
    throw new Error('Method not implemented.');
  }

  setMode(): void {
    throw new Error('Method not implemented.');
  }

  setRequiredParameters(parameter: OneSearchSearch, _: SharedRequestConfiguration): void {
    const additionalRequestConfig = this.getAdditionalRequestConfig(parameter);

    this.setQueryParameters({
      ...convertFieldsToStrings({
        ...additionalRequestConfig,
      }),
    });
  }

  private getAdditionalRequestConfig(parameter: OneSearchSearch) {
    const { brand, oneSearchFilterPrefix } = createMandatoryParameter(parameter);
    this.setPathSegment(`/search/${oneSearchFilterPrefix}`);

    const modelIdentifier = removeClassSuffixForOneSearch(parameter.modelIdentifier);
    const isVan = isCommercialVanByModelId(modelIdentifier);

    return getRequestConfiguration(isVan, { ...parameter, modelIdentifier: modelIdentifier, brand });
  }

  checkAllRequiredParametersPresent(): boolean {
    throw new Error('Method not implemented.');
  }

  async getResponse(): Promise<OptionalOneSearchSearchResponseWithId> {
    const oneSearchSearchResponse = await this.fetchTypedBody<OneSearchSearchResponse>();
    return {
      responseTypeId: 'OneSearchSearchResponse',
      ...oneSearchSearchResponse,
    };
  }
}
